var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "url(#paint0_linear_5471_19090)",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5471_19090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4622 22.1484C13.6756 22.9376 12.9379 23.6773 12.2002 24.417C12.0422 24.5756 11.8848 24.7352 11.7246 24.8917C11.5048 25.1067 11.2415 25.1274 11.0591 24.9465C10.8751 24.7646 10.8903 24.499 11.1069 24.2818C11.9592 23.4258 12.8136 22.5726 13.668 21.7188C13.7109 21.6759 13.7598 21.639 13.8244 21.5836C13.7603 21.5146 13.7136 21.4614 13.6632 21.4109C12.5172 20.2633 11.3702 19.1168 10.2242 17.9692C9.9278 17.6721 9.92129 17.4554 10.2285 17.1779C11.9863 15.5909 14.0035 15.1081 16.283 15.7745C16.4236 15.8158 16.511 15.8082 16.619 15.699C17.3719 14.9354 18.1319 14.1794 18.8919 13.4234C18.9397 13.3761 19.0048 13.3462 19.1101 13.2767C18.9321 13.1219 18.7915 13.0226 18.6775 12.8982C18.0603 12.2242 18.0776 11.1955 18.7095 10.5351C19.3392 9.87686 20.3701 9.81875 21.0698 10.4021C21.1377 10.4585 21.2023 10.5188 21.2647 10.5807C22.6517 11.9673 24.0398 13.3528 25.4235 14.742C26.1433 15.4644 26.1933 16.4832 25.5532 17.1947C24.9034 17.9171 23.8074 17.973 23.0919 17.3153C22.9725 17.2056 22.8732 17.0747 22.757 16.9449C22.6848 17.009 22.6392 17.0454 22.598 17.0861C21.8298 17.8535 21.0649 18.6236 20.293 19.3873C20.1904 19.4888 20.1823 19.5714 20.2213 19.7061C20.8787 21.9757 20.4108 23.9928 18.8425 25.7541C18.5505 26.0822 18.3301 26.0773 18.0206 25.7677C16.8839 24.6304 15.7466 23.4932 14.6115 22.3543C14.5594 22.3021 14.5241 22.2331 14.4639 22.1484H14.4622Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5471_19090",
    x1: 2,
    y1: 18,
    x2: 34,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5471_19090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin_icon.ce1620991becc860e7c64e84673ec45e.svg";
export { ForwardRef as ReactComponent };